import { useSwrData } from './swrWrapper';
import { useState } from 'react';
const BaseUrl = import.meta.env.VITE_APP_API_URL;

export const useFetchClasses = (token, filters = {}) => {
	const [instructors, setInstructors] = useState([]);

	const queryParams = new URLSearchParams();
	Object.entries(filters).forEach(([key, value]) => {
		if (Array.isArray(value) && value.length > 0) {
			queryParams.append(key, value.join(','));
		} else if (value) {
			queryParams.append(key, value);
		}
	});
	const url = `${BaseUrl}/class/getClassVideos${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
	const { data, error, isLoading } = useSwrData(url, token);
	const videos = data?.data;
	if (videos?.length > 0) {
		const filteredInstructors = [
			...new Set(
				videos.filter(video => video.instructor && video.instructor.trim() !== '').map(video => video.instructor)
			)
		];

		if (filteredInstructors.length !== instructors.length) {
			setInstructors(filteredInstructors);
		}
	}
	

	return {
		isSuccess: data?.success,
		videos: data?.data || [],
		instructors: instructors,
		isLoading: isLoading,
		isError: error,
		message: data?.message
	};
};
